<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-cyan" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-4 searching">
                <span class="h_page">Analisis Hasil Monev BOS</span>
                <br>
                <br>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4 searching">

                <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn bg-orange btn-sm waves-effect" title="Tambah Data" @click="cetak">
                      <i class="material-icons">add</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata">
                </div> <br>

              </div>
            </div>
          </div>

          <div class="col-xs-12 card">
            <!-- ============================================================ MULAI ======================================================================== -->
              <div class="container">
                <div class="table-responsive" id="printMe">



                  <table style="width: 100%">
                    <tbody  style="border-bottom: 1px solid;">
                      <tr>
                        <td style="width: 7%" rowspan="2" class="text-center">
                          <img src="images/sultra.png" class="img-responsive" width="60%"/>
                        </td>
                        <td colspan="2" class="text-center">
                          <span class="h_kop_1"><b>PEMERINTAH PROVINSI SULAWESI TENGGARA</b></span> <br>
                          <span class="h_kop_2"><b>DINAS PENDIDIKAN DAN KEBUDAYAAN</b></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center h_kop_3">
                          <span><b><i>Jl. Sultan Hasanuddin No. 1 Kendari 93123</i></b></span> <br>
                          <span><b><i> (0401) 3121374,3123102,3121024,3121874</i></b></span>
                        </td>
                        <td class="text-center h_kop_3">
                          <span><b><i>Website : http://sultra.diknas.go.id</i></b></span> <br>
                          <span><b><i>e-mail : webmail@sultra.diknas.go.id</i></b></span>
                        </td>
                      </tr>
                    </tbody>


                    <tbody>
                      <tr>
                        <td colspan="3">

                          <div class="text-center"> <br><br>
                            <b>
                              Hasil Analisis Laporan Monitoring dan Evaluasi <br>
                              BOS di SMA –SMK Negeri Se Provinsi Sulawesi Tenggara Tahun 2017
                            </b>
                          </div>
                          <br><br>
                          <div class="table-responsive">
                            <ol type="A">
                              <li><span class="h_badan1">Dasar</span>
                                <ol type="1" class="h_badan2 text-justify">
                                  <li>Undang-Undang Republik Indonesia No 20 Tahun 2003 tentang Sistem Pendidikan Nasional</li>
                                  <li>Peraturan Pemerintah Repubik Indonesia Nomor 48 Tahun 2008 tentang Pendanaan Pendidikan</li>
                                  <li>Peraturan Pemerintah Repubik Indonesia Nomor 17 Tahun 2010 tentang Pengelolaan Pendidikan</li>
                                  <li>Peraturan Menteri Pendidikan dan Kebudayaan Nomor 69 Tahun 2009 tentang Standar Biaya Pendidikan</li>
                                  <li>Peraturan Menteri Pendidikan dan Kebudayaan Nomor 60 Tahun 2011 tentang Larangan Pemungutan Biaya Pendidikan pada SD dan SMP</li>
                                  <li>Peraturan  Menteri Pendidikan dan Kebudayaan Republik Indonesia No 80 Tahun 2015 tentang Petunjuk Teknis Penggunaan Dan Pertanggungjawaban Keuangan Dana Bantuan Operasional Sekolah</li>
                                  <li>Peraturan Menteri Pendidikan dan Kebudayaan Republik Indonesia No. 8 Tahun 2017 tentang  Petunjuk Teknis Bantuan Operasional Sekolah</li>
                                  <li>Surat Tugas Kepala Dinas Pendidikan dan Kebudayaan Provinsi Sulawesi Tenggara No. ………………. untuk melaksanakan perjalanan dinas dalam daerah dalam rangka monitoring dan evaluasi …………………………. Tahun 2017 di kabupaten/kota Provinsi Sulawesi Tenggara</li>
                                </ol>
                                <br>
                              </li>

                              <li><span class="h_badan1"> Petugas yang melaksanakan perjalanan dinas</span>
                                <table style="width: 100%">
                                  <tr>
                                    <td style="width: 2%">1.</td>
                                    <td style="width: 15%">Unsur</td>
                                    <td style="width: 1%">:</td>
                                    <td>-  Pengawas SMA-SMK</td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>-  Pejabat Eselon IV/Staf Dinas Dikbud Prov. Sultra</td>
                                  </tr>
                                  <tr>
                                    <td>2.</td>
                                    <td>Jumlah</td>
                                    <td>:</td>
                                    <td>…….. orang</td>
                                  </tr>
                                </table> <br>
                              </li>

                              <li><span class="h_badan1"> Waktu dan tempat pelaksanaan perjalanan dinas</span>
                                <table style="width: 100%">
                                  <tr>
                                    <td style="width: 2%">1.</td>
                                    <td style="width: 15%">Periode waktu</td>
                                    <td style="width: 1%">:</td>
                                    <td>-  Pengawas SMA-SMK</td>
                                  </tr>
                                  <tr>
                                    <td>2.</td>
                                    <td>Tempat</td>
                                    <td>:</td>
                                    <td>…….. orang</td>
                                  </tr>
                                </table> <br>
                              </li>

                              <li><span class="h_badan1"> Tekhnis pengumpulan data dan jumlah sekolah</span>
                                <table style="width: 100%">
                                  <tr>
                                    <td style="width: 2%">1.</td>
                                    <td style="width: 18%">Tekhnik pengumpulan data</td>
                                    <td style="width: 1%">:</td>
                                    <td>-  Pengawas SMA-SMK</td>
                                  </tr>
                                  <tr>
                                    <td>2.</td>
                                    <td>Tempat</td>
                                    <td>:</td>
                                    <td>…….. orang</td>
                                  </tr>
                                </table> <br>
                              </li>

                              <li class="text-justify"><span class="h_badan1"> Substansi Monev</span> <br>
                                Substansi Monev meliputi pengecekan ketersediaan dokumen, pelaksanaan, dan pelaporan pengelolaan Dana Bantuan Operasional Sekolah SMA-SMK negeri se Provinsi Sulawesi Tenggara Tahun 2017 mencakup tiga (3) aspek yaitu: pengelolaan, bendahara, dan pembiayaan dan meliputi enam belas (16) pertanyaan, yaitu:
                                <ol type="1" class="h_badan2">
                                  <li>Sekolah Menyusun RKAS 2017</li>
                                  <li>Sekolah Melibatkan dewan guru dan komite dalam menyusun rencana penggunaan  dana BOS yang ditandai dengan berita acara</li>
                                  <li>Sekolah menginformasikan dana BOS yang diterima dan rencana penggunaan dana BOS di papan pengumuman sekolah</li>
                                  <li>Telah memiliki SK  Tim Manajemen BOS Sekolah sesuai juklak BOS</li>
                                  <li>Masih adakah pungutan kepada orang tua siswa (bebas pungutan) bagi seluruh siswa (untuk sekolah negeri) dan bebas pungutan bagi siswa miskin (untuk sekolah swasta)</li>
                                  <li>Apakah ada masalah terhadap penerimaan dana BOS (seperti pungutan liar, terlambat cair dll)</li>
                                  <li>Apakah dan BOS yang diterima sesuai dengan jumlah siswa</li>
                                  <li>Pengambilan dana  BOS dilakukan oleh Bendahara Sekolah dan disetujui oleh Kepala Sekolah</li>
                                  <li>Jumlah dana yang dicairkan disesuaikan dengan kebutuhan sekolah (sesuai rencana pengeluaran sekolah)</li>
                                  <li>Telah menyusun laporan realisasi penggunaan dana BOS triwulan I tahun 2017 melalui format BOS - K7</li>
                                  <li>Penggunaan dana BOS Triwulan I sesuai dengan alokasi RKAS BOS Triwulan I</li>
                                  <li>Kegiatan pembelajaran dan ekstrakurikuler berjalan lancer</li>
                                  <li>Gedung sekolah terawat dengan baik</li>
                                  <li>WC Sekolah terawat dengan baik</li>
                                  <li>Air bersih di sekolah tersedia cukup dan lancer</li>
                                  <li>Lingkungan / taman sekolah tertata dengan rapi, rimbun dan bersih</li>
                                </ol><br>
                                Instrumen Monev Pengelolaan Dana BOS di SMA-SMK negeri se Provinsi Sulawesi Tenggara sebagaimana terlampir (Lampiran 2)
                                 <br><br>

                              </li>
                              <li class="text-justify"><span class="h_badan1"> Hasil Monev BOS</span>
                                <ol type="1" class="h_badan2">
                                  <li><span style="font-weight: bold;">Pengelolaan Dana BOS</span> <br>
                                      Data pengelolaan Dana BOS yang ditanyakan meliputi:
                                      <ol type="a" class="h_badan2">
                                        <li>Sekolah Menyusun RKAS 2017</li>
                                        <li>Sekolah melibatkan dewan guru dan komite dalam menyusun rencana penggunaan  dana BOS yang ditandai dengan berita acara</li>
                                        <li>Sekolah menginformasikan dana BOS yang diterima dan rencana penggunaan dana BOS di papan pengumuman sekolah</li>
                                        <li>Sekolah telah memiliki SK  Tim Manajemen BOS Sekolah sesuai juklak BOS</li>
                                        <li>Sekolah masih melakukan pungutan biaya kepada orang tua siswa (bebas pungutan) bagi seluruh siswa (SMA negeri atau swasta)</li>
                                        <li>Apakah ada masalah terhadap penerimaan dana BOS (seperti pungutan liar, terlambat cair dll)</li>
                                        <li>Apakah dan BOS yang diterima sesuai dengan jumlah siswa</li>
                                      </ol> <br>
                                      Data rerata pengelolaan Dana BOS oleh SMAse Provinsi Sulawesi Tenggara ditinjau dari aspek pengelolaan ditunjukkan dalam Tabel 1 dan Grafik 1 sebagai berikut: <br>
                                      <br>

                                      <app-tabel_1></app-tabel_1>
                                      
                                      <br>
                                      Berdasarkan Tabel 1 dan Grafik 1, diketahui bahwa terdapat satu aspek pengelolaan yang pencapaiannya di atas 90%, yaitu:
                                      (a) Sekolah memiliki RKAS; Terdapat  dua aspek pengelolaan yang pencapaiannya di atas 80%, yaitu:
                                      (b) Sekolah melibatkan dewan guru dan komite dalam menyusun rencana penggunaan  dana BOS yang ditandai dengan berita acara dan
                                      (d) Sekolah telah memiliki SK  Tim Manajemen BOS Sekolah sesuai juklak BOS. Terdapat  dua aspek pengelolaan yang pencapaiannya di atas 70%, yaitu:
                                      (c) Sekolah menginformasikan dana BOS yang diterima dan rencana penggunaan dana BOS di papan pengumuman sekolah dan (g) Apakah dana BOS yang diterima sesuai dengan jumlah siswa. Sebaliknya terdapat dua (2) aspek yang pencapaiannya kurang dari 60%, yaitu:
                                      (f)  Apakah ada masalah terhadap penerimaan dana BOS (seperti pungutan liar, terlambat cair dll) dan (e) Sekolah masih melakukan pungutan biaya kepada orang tua siswa (bebas pungutan) bagi seluruh siswa.
                                      <br><br>
                                      Secara singkat data ke-tujuh aspek pengelolaan tersebut di setiap kabupaten/kota disajikan dalam bentuk tabel dan grafik sebagai berikut; <br><br>

                                      <ol type="a" class="h_badan2 text-justify">
                                        <li><b>Sekolah Menyusun RKAS 2017 </b><br><br>
                                          Data keberadaan dokumen RKAS  di SMA se kabupaten/kota se Provinsi Sulawesi Tenggara sebagaimana ditunjukkan pada Tabel 2 dan Grafik 2 sebagai berikut: <br>
                                          <br><br>
                                          <div class="text-center">Tabel 2. Rerata Persentase Keberadaan RKAS</div> <br>
                                          
                                          <app-tabel_2></app-tabel_2>

                                          Berdasarkan Tabel 2 dan Grafik 2 diketahui rata-rata keberadaan RKAS sekolah di Kab/Kota adalah 99,5%. Sekolah yang tidak memiliki RKAS, terdapat satu (1) sekolah di Kabupaten Muna (SMAS Darul Fikri Labungka).
                                          <br><br>
                                          



                                        </li>
                                        <li><b>Keterlibatan Dewan Guru dan Komite Sekolah</b> <br><br>
                                          Data rata-rata sekolah yang menginformasikan dana BOS yang diterima dan rencana penggunaan dana BOS di papan pengumuman sekolah 
                                          di kabupaten/kota se Provinsi Sulawesi Tenggara sebagaimana ditunjukkan pada Tabel 4 dan Grafik 4 sebagai berikut:
                                          <br><br>
                                          <div class="text-center">Tabel 3. Keterlibatan Dewan Guru & Komsek</div> <br>

                                          <app-tabel_3></app-tabel_3>

                                          Berdasarkan Tabel 3 dan Grafik 3 diketahui bahwa rata-rata keterlibatan Dewan Guru dan Komite Sekolah dalam penyusunan program kerja sekolah yang dibiayai dari Dana BOS adalah 88,1%.  
                                          Terdapat lima (5) kabupaten/kota yang sekolahnya tidak mencapai seratus persen secara berurutan mulai dari yang tertinggi ke terendah adalah sebagai berikut: 
                                          (a)  Buton Selatan (92%), 
                                          (b) Muna Barat (83%), 
                                          (c) Konawe (73%), 
                                          (d) Buton Utara (50%), dan (e) Kolaka Utara (0%).
                                          <br>

                                          <br>
                                        </li>
                                        <li><b>Sekolah Menginformasikan  Dana BOS yang Diterima dan Pembiayaannya</b> <br><br>
                                          Data sekolah yang mengumumkan dana BOS yang diterima dan pembiayaannya melalui papan pengumuman sekolah di SMA se kabupaten/kota se Provinsi Sulawesi Tenggara sebagaimana ditunjukkan pada Tabel 4 dan Grafik 4 sebagai berikut:
                                          <br><br>
                                          <div class="text-center">Tabel 4. Sekolah  yang Mengumumkan Dana BOS di Papan Pengumuman</div> <br>

                                          <app-tabel_4></app-tabel_4>

                                          Berdasarkan Tabel 4 dan Grafik 4 diketahui bahwa rata-rata sekolah yang mengumumkan jumlah Dana Bos yang diterima dan pembiayaannya di papan pengumuman sekolah adalah 74,73%.  
                                          Terdapat tiga (3) kabupaten yang skor pencapaiannya seratus persen, yaitu: (a) Kolaka utara, (b) Konawe Kepulauan, dan (c) Muna. 
                                          Sekolah lainnya umumnya tetap mengumumkan  tetapi tidak di papan pengumuman sekolah, antara lain diumumkan pada saat rapat dengan dewan guru dn komite sekolah.
                                          Pencapaian kabupaten/kota lainnya  secara berurutan yaitu: 
                                          (a) Bombana (92%), 
                                          (b) Buton Selatan (92%), 
                                          (c) Buton (88%), 
                                          (d) Buton Tengah (80%), 
                                          (e) Konawe (73%), 
                                          (f) Konawe Selatan (71%), (g) Wakatobi (71%), (h) Baubau (67%), (i) Kendari (67%), (j) Kolaka (67%), (k) Konawe Utara (67%), (l) Muna Barat (67%), dan (m) Buton Utara (50%), serta (n) Kolaka Timur (20%).

                                          <br><br>
                                        </li>
                                        <li><b>Sekolah Memiliki Tim Manajemen BOS</b> <br><br>
                                          Data sekolah memiliki Tim Manajemen BOS yang ditetapkan dengan surat keputusan kepala sekolah di SMA 
                                          se kabupaten/kota se Provinsi Sulawesi Tenggara sebagaimana ditunjukkan pada Tabel 5 dan Grafik 5 sebagai berikut:
                                          <br><br>
                                          <div class="text-center">Tabel 5. Data Tim Manajemen Dana BOS</div> <br>

                                          <app-tabel_5></app-tabel_5>
                                          
                                          Berdasarkan Tabel 5 dan Grafik 5 diketahui bahwa rata-rata sekolah yang telah mengangkat dan mengesahkan Tim Manajemen Dana BOS di SMA se Provinsi Sulawesi Tenggara adalah 84,66%.  
                                          Terdapat delapan (8) kabupaten yang skor pencapaiannya seratus persen, yaitu: 
                                          Baubau, Buton, Buton Tengah, Buton Utara, Kendari, Konawe, Konawe Utara, dan Muna. Pencapaian pada kabupaten lainnya bervariasi, 
                                          secara umum dikelompokkan menjadi dua. Kabupaten yang pencapaian di atas 70% adalah: Bombana (92.31%), Kolaka Utara (90,91%), Buton Selatan (90.00%), 
                                          Konawe Kepulauan (85,71%), Wakatobi (85,51%), Konawe Selatan (83,33%), dan Muna Barat (71,43%). 
                                          Kabupaten yang pencapaiannya kurang dari tujuh puluh persen, yaitu: Kabupaten Kolaka (40%) dan Kolaka Timur (0%).
                                          <br><br>
                                        </li>
                                        <li><b>Sekolah Melakukan  Pungutan Biaya Sekolah</b></li>
                                        <li><b>Masalah Dalam Penerimaan Dana BOS</b></li>
                                        <li><b>Kesesuaian Jumlah Dana BOS dengan Jumlah Siswa</b></li>
                                      </ol>
                                  </li>
                                </ol>
                                <!-- <GChart class="chartku" type="ColumnChart" :data="chartData" :options="chartOptions"/> <hr> -->
                                <br>
                              </li>
                              <li><span class="h_badan1"> Bendahara Dana BOS</span>
                              </li>
                              <li><span class="h_badan1"> Pembiayaan Dana BOS</span>
                              </li>
                              <li><span class="h_badan1"> Kesimpulan dan Rekomendasi</span>
                              </li>
                            </ol>
                          </div>


                        </td>
                      </tr>
                    </tbody>



                  </table> <br>
                  <hr>








                </div>
              </div>


            <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>



<script>

const ADD_URL = URL_APP + "api/v1/instrumen_guru/";
import uniqid from "uniqid";

export default {

  name: "monev_instrumen_guru",
  data: function() {
    return {
      ada: "ada",

    };
  },

  methods: {

    cetak: function(){
      // printMe
      var elem = document.getElementById("printMe");
      var domClone = elem.cloneNode(true);

      var $printSection = document.getElementById("printSection");

      if (!$printSection) {
          var $printSection = document.createElement("div");
          $printSection.id = "printSection";
          document.body.appendChild($printSection);
      }

      $printSection.innerHTML = "";
      $printSection.appendChild(domClone);
      window.print();
    },

  },

  // =============================================================== METHODS =========================================================================

  mounted() {

  }
};
</script>
